import classNames from 'classnames';
import React from 'react';
import { Card } from 'react-bootstrap';
import { Color, Variant } from 'react-bootstrap/types';

export interface SlimPageCardProps
    extends React.HTMLAttributes<HTMLElement> {
    bg?: Variant;
    text?: Color;
    border?: Variant;
    body?: boolean;
}

export const SlimPageCard = (props: React.PropsWithChildren<SlimPageCardProps>) => {

    //all the properties are passed to the card, including children, the card renders the children.
    return (
        <Card {...props} className={classNames("page-card", props.className)}>
        </Card>);
};

SlimPageCard.defaultProps = {
    border: "0",
    body: true,
    bg: 'white',
    text: 'dark'
}

export default SlimPageCard;
